export default __webpack_public_path__ + "static/media/traditional_row_start.3c63fddf.svg";